(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(19114);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35059);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29222);


const colors = {
    default: {
        bg: "base",
        color: "textLight",
        _hover: {
            boxShadow: "0px 6px 12px rgba(44, 39, 56, 0.06), 0px 12px 24px rgba(20, 20, 20, 0.1)"
        },
        _active: {
            bg: "base",
            opacity: 0.8
        }
    },
    accent: {
        bg: "secondary",
        color: "textLight",
        _hover: {
            boxShadow: "0px 6px 12px rgba(44, 39, 56, 0.06), 0px 12px 24px rgba(44, 39, 56, 0.1)"
        },
        _active: {
            bg: "secondary",
            opacity: 0.8
        }
    },
    danger: {
        bg: "error",
        color: "textLight",
        _hover: {
            boxShadow: "0px 6px 12px rgba(44, 39, 56, 0.06), 0px 12px 24px rgba(44, 39, 56, 0.1)"
        },
        _active: {
            bg: "error",
            opacity: 0.8
        }
    },
    outline: {
        bg: "white",
        color: "textDark",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "placeholder",
        _hover: {
            boxShadow: "0px 6px 12px rgba(44, 39, 56, 0.06), 0px 12px 24px rgba(20, 20, 20, 0.1)"
        },
        _active: {
            bg: "white",
            opacity: 0.8
        }
    }
};
const disabledColor = {
    bg: "base",
    color: "textLight",
    _hover: {
        bg: "base"
    },
    _active: {
        bg: "base"
    }
};
const sizes = {
    default: {
        w: "full",
        maxW: "400px",
        h: "48px"
    },
    sm: {
        h: 8,
        px: 4,
        fontSize: "sm"
    }
};
const Button = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)((param, ref)=>{
    let { color ="default" , size ="default" , disabled: defaultDisabled , isLoading , ...props } = param;
    const disabled = defaultDisabled || isLoading;
    const colorProps = disabled ? disabledColor : colors[color];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
        ref: ref,
        disabled: disabled,
        isLoading: isLoading,
        fontWeight: "normal",
        ...colorProps,
        ...sizes[size],
        ...props,
        children: props.children
    });
});
Button.displayName = "Button";


/***/ }),

/***/ 68725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ButtonLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41385);



const ButtonLink = (param)=>{
    let { href , isExternal , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
        as: (next_link__WEBPACK_IMPORTED_MODULE_1___default()),
        href: href,
        passHref: true,
        target: isExternal ? "_blank" : undefined,
        ...props,
        children: children
    });
};
ButtonLink.displayName = "ButtonLink";


/***/ }),

/***/ 41151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33838);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);



const Link = (param)=>{
    let { href , color ="secondary" , onClick , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r, {
        as: (next_link__WEBPACK_IMPORTED_MODULE_1___default()),
        href: href || "#",
        passHref: true,
        color: color,
        onClick: onClick ? (e)=>{
            e.preventDefault();
            onClick(e);
        } : undefined,
        ...props,
        children: children
    });
};
Link.displayName = "Link";


/***/ }),

/***/ 49441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36979);


const Container = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W, {
        ...props,
        children: children
    });
};
Container.displayName = "Container";


/***/ }),

/***/ 89889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ ErrorPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23100);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90634);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14418);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88911);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_elements_ButtonLink_ButtonLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68725);
/* harmony import */ var _components_metas_Title_Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96981);
/* harmony import */ var _Container_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49441);
/* harmony import */ var _Header_Header__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91003);
/* harmony import */ var _Wrapper_Wrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85782);








const ErrorPage = (param)=>{
    let { title , description , link  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Wrapper_Wrapper__WEBPACK_IMPORTED_MODULE_6__/* .Wrapper */ .i, {
        header: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Header_Header__WEBPACK_IMPORTED_MODULE_5__/* .Header */ .h, {}),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: "noindex"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_metas_Title_Title__WEBPACK_IMPORTED_MODULE_3__/* .Title */ .D, {
                title: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container_Container__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                    position: "fixed",
                    top: 50,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .VStack */ .g, {
                        h: "100%",
                        justifyContent: "center",
                        alignItems: "stretch",
                        spacing: 8,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .VStack */ .g, {
                                justifyContent: "center",
                                spacing: 4,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Heading */ .X, {
                                        fontSize: "lg",
                                        textAlign: "center",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                        fontSize: "sm",
                                        textAlign: "center",
                                        children: description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .VStack */ .g, {
                                flexBasis: "80px",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container_Container__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
                                    textAlign: "center",
                                    children: link || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_ButtonLink_ButtonLink__WEBPACK_IMPORTED_MODULE_2__/* .ButtonLink */ .Z, {
                                        href: "/",
                                        children: "トップページへ"
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
ErrorPage.displayName = "ErrorPage";


/***/ }),

/***/ 91003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95034);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88911);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24804);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(204);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36953);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66303);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(46887);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(40989);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_hi__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(53854);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20956);
/* harmony import */ var _components_elements_Link_Link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41151);







const Header = (param)=>{
    let { title , ...props } = param;
    const left = title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HeaderLogo, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Spacer */ .L, {});
    const center = title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
        textAlign: "center",
        color: "white",
        children: title
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HeaderLogoHorizontal, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .HStack */ .U, {
        h: "50px",
        position: "sticky",
        top: 0,
        left: 0,
        right: 0,
        bg: "base",
        paddingX: 4,
        justifyContent: "space-between",
        alignItems: "center",
        zIndex: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .k, {
                flexBasis: "50px",
                justifyContent: "flex-start",
                children: left
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .k, {
                flex: 1,
                justifyContent: "center",
                children: center
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .k, {
                flexBasis: "50px",
                justifyContent: "flex-end",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HeaderMenu, {})
            })
        ]
    });
};
const HeaderLogo = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Link_Link__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .r, {
        href: "/",
        lineHeight: 1,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: "/images/logoWhite.png",
            width: 32,
            height: 32,
            alt: "トレーニングシェア"
        })
    });
};
const HeaderLogoHorizontal = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Link_Link__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .r, {
        href: "/",
        lineHeight: 1,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: "/images/logoHorizontal.png",
            width: 142,
            height: 32,
            alt: "トレーニングシェア"
        })
    });
};
const HeaderMenu = ()=>{
    const { isAuthenticated , isActionRequired  } = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const isGuest = !isAuthenticated && !isActionRequired;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Menu */ .v, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .MenuButton */ .j, {
                "aria-label": "メニュー",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_11__/* .HiMenu */ .r0I, {
                    color: "white",
                    size: 28
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .MenuList */ .q, {
                children: [
                    isGuest && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/"),
                                children: "トップページ"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/signup"),
                                children: "メールアドレスで登録"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/signin"),
                                children: "ログイン"
                            })
                        ]
                    }),
                    isAuthenticated && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/top?howToUse=open"),
                                children: "トレーニングシェアとは"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/news"),
                                children: "新着情報一覧"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/glossary"),
                                children: "用語集"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/profile"),
                                children: "プロフィール編集"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                                onClick: ()=>router.push("/credit_card"),
                                children: "クレジットカード変更"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                        onClick: ()=>router.push("/contact"),
                        children: "お問い合わせ"
                    }),
                    !isGuest && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .MenuItem */ .s, {
                        onClick: ()=>router.push("/signout"),
                        children: "ログアウト"
                    })
                ]
            })
        ]
    });
};
Header.displayName = "Header";


/***/ }),

/***/ 85782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23100);


const Wrapper = (param)=>{
    let { header , footer , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
        children: [
            header,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                pb: footer ? 20 : 4,
                children: children
            }),
            footer
        ]
    });
};
Wrapper.displayName = "Wrapper";


/***/ }),

/***/ 96981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Title; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


const Title = (param)=>{
    let { title , override =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
            children: "\n          ".concat(title, "\n          ").concat(override ? "" : "｜トレーニングシェア", "\n        ")
        })
    });
};


/***/ }),

/***/ 19114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _404; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/layouts/ErrorPage/ErrorPage.tsx
var ErrorPage = __webpack_require__(89889);
;// CONCATENATED MODULE: ./components/pages/Error/NotFound.tsx


const NotFoundPage = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* ErrorPage */.m, {
        title: "ページが見つかりませんでした",
        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "申し訳ございません。",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "指定されたページは移動、削除されたか",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "一時的に利用できない可能性がございます。"
            ]
        })
    });
};
/* harmony default export */ var NotFound = (NotFoundPage);

;// CONCATENATED MODULE: ./pages/404.tsx


const Custom404 = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound, {});
};
/* harmony default export */ var _404 = (Custom404);


/***/ }),

/***/ 29222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/button/dist/chunk-FRFD4OXU.mjs
// src/use-button-type.tsx

function useButtonType(value) {
  const [isButton, setIsButton] = (0,react.useState)(!value);
  const refCallback = (0,react.useCallback)((node) => {
    if (!node)
      return;
    setIsButton(node.tagName === "BUTTON");
  }, []);
  const type = isButton ? "button" : void 0;
  return { ref: refCallback, type };
}



// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-context/dist/index.mjs
var dist = __webpack_require__(55227);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/button/dist/chunk-DGWZA2DU.mjs
// src/button-context.ts

var [ButtonGroupProvider, useButtonGroup] = (0,dist/* createContext */.k)({
  strict: false,
  name: "ButtonGroupContext"
});



// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-3LE6AY5Q.mjs + 6 modules
var chunk_3LE6AY5Q = __webpack_require__(82504);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/shared-utils/dist/index.mjs
var shared_utils_dist = __webpack_require__(25432);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/button/dist/chunk-HCASMTTF.mjs
// src/button-icon.tsx




function ButtonIcon(props) {
  const { children, className, ...rest } = props;
  const _children = (0,react.isValidElement)(children) ? (0,react.cloneElement)(children, {
    "aria-hidden": true,
    focusable: false
  }) : children;
  const _className = (0,shared_utils_dist.cx)("chakra-button__icon", className);
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    chunk_3LE6AY5Q/* chakra.span */.m.span,
    {
      display: "inline-flex",
      alignSelf: "center",
      flexShrink: 0,
      ...rest,
      className: _className,
      children: _children
    }
  );
}
ButtonIcon.displayName = "ButtonIcon";



// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/chunk-NO6MRLPK.mjs
var chunk_NO6MRLPK = __webpack_require__(295);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/button/dist/chunk-HNNHG6RU.mjs
// src/button-spinner.tsx





function ButtonSpinner(props) {
  const {
    label,
    placement,
    spacing = "0.5rem",
    children = /* @__PURE__ */ (0,jsx_runtime.jsx)(chunk_NO6MRLPK/* Spinner */.$, { color: "currentColor", width: "1em", height: "1em" }),
    className,
    __css,
    ...rest
  } = props;
  const _className = (0,shared_utils_dist.cx)("chakra-button__spinner", className);
  const marginProp = placement === "start" ? "marginEnd" : "marginStart";
  const spinnerStyles = (0,react.useMemo)(
    () => ({
      display: "flex",
      alignItems: "center",
      position: label ? "relative" : "absolute",
      [marginProp]: label ? spacing : 0,
      fontSize: "1em",
      lineHeight: "normal",
      ...__css
    }),
    [__css, label, marginProp, spacing]
  );
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(chunk_3LE6AY5Q/* chakra.div */.m.div, { className: _className, ...rest, __css: spinnerStyles, children });
}
ButtonSpinner.displayName = "ButtonSpinner";



// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-merge-refs/dist/index.mjs
var react_use_merge_refs_dist = __webpack_require__(81103);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-QEVFQ4EU.mjs
var chunk_QEVFQ4EU = __webpack_require__(35059);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-T2VHL7RE.mjs
var chunk_T2VHL7RE = __webpack_require__(91639);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/styled-system/dist/index.mjs
var styled_system_dist = __webpack_require__(33179);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/button/dist/chunk-NAA7TEES.mjs





// src/button.tsx





var Button = (0,chunk_QEVFQ4EU/* forwardRef */.G)((props, ref) => {
  const group = useButtonGroup();
  const styles = (0,chunk_T2VHL7RE/* useStyleConfig */.mq)("Button", { ...group, ...props });
  const {
    isDisabled = group == null ? void 0 : group.isDisabled,
    isLoading,
    isActive,
    children,
    leftIcon,
    rightIcon,
    loadingText,
    iconSpacing = "0.5rem",
    type,
    spinner,
    spinnerPlacement = "start",
    className,
    as,
    ...rest
  } = (0,styled_system_dist/* omitThemingProps */.Lr)(props);
  const buttonStyles = (0,react.useMemo)(() => {
    const _focus = { ...styles == null ? void 0 : styles["_focus"], zIndex: 1 };
    return {
      display: "inline-flex",
      appearance: "none",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none",
      position: "relative",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      outline: "none",
      ...styles,
      ...!!group && { _focus }
    };
  }, [styles, group]);
  const { ref: _ref, type: defaultType } = useButtonType(as);
  const contentProps = { rightIcon, leftIcon, iconSpacing, children };
  return /* @__PURE__ */ (0,jsx_runtime.jsxs)(
    chunk_3LE6AY5Q/* chakra.button */.m.button,
    {
      ref: (0,react_use_merge_refs_dist/* useMergeRefs */.qq)(ref, _ref),
      as,
      type: type != null ? type : defaultType,
      "data-active": (0,shared_utils_dist/* dataAttr */.PB)(isActive),
      "data-loading": (0,shared_utils_dist/* dataAttr */.PB)(isLoading),
      __css: buttonStyles,
      className: (0,shared_utils_dist.cx)("chakra-button", className),
      ...rest,
      disabled: isDisabled || isLoading,
      children: [
        isLoading && spinnerPlacement === "start" && /* @__PURE__ */ (0,jsx_runtime.jsx)(
          ButtonSpinner,
          {
            className: "chakra-button__spinner--start",
            label: loadingText,
            placement: "start",
            spacing: iconSpacing,
            children: spinner
          }
        ),
        isLoading ? loadingText || /* @__PURE__ */ (0,jsx_runtime.jsx)(chunk_3LE6AY5Q/* chakra.span */.m.span, { opacity: 0, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(ButtonContent, { ...contentProps }) }) : /* @__PURE__ */ (0,jsx_runtime.jsx)(ButtonContent, { ...contentProps }),
        isLoading && spinnerPlacement === "end" && /* @__PURE__ */ (0,jsx_runtime.jsx)(
          ButtonSpinner,
          {
            className: "chakra-button__spinner--end",
            label: loadingText,
            placement: "end",
            spacing: iconSpacing,
            children: spinner
          }
        )
      ]
    }
  );
});
Button.displayName = "Button";
function ButtonContent(props) {
  const { leftIcon, rightIcon, children, iconSpacing } = props;
  return /* @__PURE__ */ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [
    leftIcon && /* @__PURE__ */ (0,jsx_runtime.jsx)(ButtonIcon, { marginEnd: iconSpacing, children: leftIcon }),
    children,
    rightIcon && /* @__PURE__ */ (0,jsx_runtime.jsx)(ButtonIcon, { marginStart: iconSpacing, children: rightIcon })
  ] });
}




/***/ }),

/***/ 14418:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Heading; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35059);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91639);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33179);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82504);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25432);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
// src/heading.tsx



var Heading = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .G)(function Heading2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useStyleConfig */ .mq)("Heading", props);
  const { className, ...rest } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .chakra.h2 */ .m.h2,
    {
      ref,
      className: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_5__.cx)("chakra-heading", props.className),
      ...rest,
      __css: styles
    }
  );
});
Heading.displayName = "Heading";




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6556,1191,5982,9059,9774,2888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);